






































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";


@Component({
  components: {
  }
})

export default class AskConvert3dTextAlertModal extends Vue {
    isVisible = false;
    callback : ((ret : boolean) => void) | null = null;
    
    onCancel(){
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        this.isVisible = false;
        if(this.callback != null) this.callback(false);
    }

    onOk() {
        this.isVisible = false;
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        if(this.callback != null) this.callback(true);
    }

    public open(callback : (ret : boolean) => void) {
        this.callback = callback;
        this.isVisible = true;
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
